/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreateTeamDto,
  Team,
  TeamUsers,
  UpdateTeamDto,
  UpdateTeamMembersRequest,
  UpdateTeamsPayload,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiTeamsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-teams-controller
   * @name GetById
   * @summary Return team by team id
   * @request GET:/api/v1/teams/{teamId}
   */
  getById = (teamId: string, params: RequestParams = {}) =>
    this.http.request<Team, any>({
      path: `/v1/teams/${teamId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByIdPath = '/v1/teams/${teamId}'
  static getByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-teams-controller
   * @name UpdateTeam
   * @request PUT:/api/v1/teams/{teamId}
   */
  updateTeam = (teamId: string, data: UpdateTeamDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/teams/${teamId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateTeamPath = '/v1/teams/${teamId}'
  static updateTeamMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-teams-controller
   * @name DeleteTeam
   * @request DELETE:/api/v1/teams/{teamId}
   */
  deleteTeam = (teamId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/teams/${teamId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteTeamPath = '/v1/teams/${teamId}'
  static deleteTeamMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-teams-controller
   * @name UpdateTeamMembers
   * @request PUT:/api/v1/teams/{teamId}/team-members
   */
  updateTeamMembers = (
    teamId: string,
    data: UpdateTeamMembersRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/teams/${teamId}/team-members`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateTeamMembersPath = '/v1/teams/${teamId}/team-members'
  static updateTeamMembersMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-teams-controller
   * @name GetByOrganisationId
   * @request GET:/api/v1/teams
   */
  getByOrganisationId = (params: RequestParams = {}) =>
    this.http.request<TeamUsers[], any>({
      path: `/v1/teams`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByOrganisationIdPath = '/v1/teams'
  static getByOrganisationIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-teams-controller
   * @name CreateTeam
   * @request POST:/api/v1/teams
   */
  createTeam = (data: CreateTeamDto, params: RequestParams = {}) =>
    this.http.request<TeamUsers, any>({
      path: `/v1/teams`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createTeamPath = '/v1/teams'
  static createTeamMethod = 'POST'
  /**
   * No description
   *
   * @tags api-teams-controller
   * @name UpdateTeams
   * @request POST:/api/v1/teams/bulk_update
   */
  updateTeams = (data: UpdateTeamsPayload, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/teams/bulk_update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateTeamsPath = '/v1/teams/bulk_update'
  static updateTeamsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-teams-controller
   * @name GetByIds
   * @summary Receive a list of team ids separate by comma and returns a list of teams
   * @request GET:/api/v1/teams/{teamIds}
   */
  getByIds = (teamIds: string[], params: RequestParams = {}) =>
    this.http.request<Team[], any>({
      path: `/v1/teams/${teamIds}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByIdsPath = '/v1/teams/${teamIds}'
  static getByIdsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-teams-controller
   * @name GetByTeamLeadId
   * @request GET:/api/v1/teams/team-lead
   */
  getByTeamLeadId = (params: RequestParams = {}) =>
    this.http.request<TeamUsers[], any>({
      path: `/v1/teams/team-lead`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByTeamLeadIdPath = '/v1/teams/team-lead'
  static getByTeamLeadIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-teams-controller
   * @name DeleteTeamLeadFromTeam
   * @request DELETE:/api/v1/teams/{teamId}/team-lead
   */
  deleteTeamLeadFromTeam = (teamId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/teams/${teamId}/team-lead`,
      method: 'DELETE',
      ...params,
    })

  static deleteTeamLeadFromTeamPath = '/v1/teams/${teamId}/team-lead'
  static deleteTeamLeadFromTeamMethod = 'DELETE'
}
